export const heldAddOnCount = (hold, addOnId) => (
  ((hold && hold.add_on_items) || []).find((item) => item.add_on_id === addOnId)?.quantity
);

const availableWithHold = (publicCount, held, hold) => (
  hold.capped_by_hold ? held : publicCount + held
);

const quantityOptions = (addOn, available) => {
  const max = Math.min(addOn.maximum_per_order, available);
  const options = [];
  for (let quantity = addOn.minimum_per_order; quantity <= max; quantity++) {
    options.push(quantity);
  }
  return options.includes(0) ? options : [0, ...options];
};

export const withHeldAddOns = (addOns, hold) => addOns.map((addOn) => {
  const unlocked = addOn.public_available_tickets !== undefined;
  const publicCount = unlocked ? addOn.public_available_tickets : addOn.available_tickets;
  const held = heldAddOnCount(hold, addOn.id);

  if (held === undefined) {
    if (!unlocked) {
      return addOn;
    }

    const { public_available_tickets, public_quantity_options, ...rest } = addOn;
    return { ...rest, available_tickets: publicCount, quantity_options: public_quantity_options, current_quantity_options: null };
  }

  const available = availableWithHold(publicCount, held, hold);
  if (unlocked && addOn.available_tickets === available) {
    return addOn;
  }

  return {
    ...addOn,
    public_available_tickets: publicCount,
    public_quantity_options: unlocked ? addOn.public_quantity_options : addOn.quantity_options,
    available_tickets: available,
    quantity_options: quantityOptions(addOn, available),
    current_quantity_options: null,
  };
});

export const withHeldAddOnCounts = (addOnCounts, hold) => addOnCounts.map((addOnCount) => {
  const held = heldAddOnCount(hold, addOnCount.id);
  return held === undefined ? addOnCount : { ...addOnCount, available_tickets: availableWithHold(addOnCount.available_tickets, held, hold) };
});
